import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Header } from '../../components/Header';
import { Load } from '../../components/Load';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { FormGroup } from '../../components/FormGroup';
import { Label } from '../../components/Label';
import InputMask from 'react-input-mask';
import AlertMessage from '../../components/Alert';
import api from '../../services/api';
import './style.css';
import { Options, Select } from '../../components/Select';

export function EmpresasCadastrar() {
    const [isLoading, setIsLoading] = useState(false);

    {/* Informações Gerais */ }
    const [cnpj, setCnpj] = useState("");
    const [cei, setCEI] = useState("");
    const [inscricaoEstadual, setInscricaoEstadual] = useState("");
    const [cnae, setCnae] = useState("");
    const [telefone, setTelefone] = useState("");
    const [celular, setCelular] = useState("");
    const [site, setSite] = useState("");
    const [razaoSocial, setRazaoSocial] = useState("");

    {/* Informações Residenciais */ }
    const [cep, setCep] = useState('');
    const [endereco, setEndereco] = useState('');
    const [numero, setNumero] = useState('');
    const [bairro, setBairro] = useState('');
    const [complemento, setComplemento] = useState('');
    const [estado, setEstado] = useState('');
    const [email, setEmail] = useState('');
    const [cidade, setCidade] = useState('');
    const [obs, setobs] = useState('');

    const [responsaveis, setResponsaveis] = useState([]);
    const [fieldError, setFieldErrors]: any = useState([]);
    const [responsavelSelecionado, setResponsavelSelecionado] = useState(null);
    const [idResponsavel, setResponsavelId] = useState(null);

    const [respNome, setRespNome] = useState('');
    const [respTelefone, setRespTelefone] = useState('');
    const [respCargo, setRespCargo] = useState('');
    const [respEmail, setRespEmail] = useState('');

    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const inputRef = useRef(null);
    const { cre, rep } = useParams();

    // useEffect(() => {
    //     setTimeout(() => {
    //         setIsLoading(false);
    //     }, 1000);
    // });

    useEffect(() => {
        const cnpjLimpo = cnpj.replace(/[\.\-\/\s]/g, '').toUpperCase();

        if (cnpjLimpo.length === 14) {
            const buscarDadosEmpresa = async () => {
                try {
                    const response = await api.get(`base-listar-empresa/${cnpjLimpo}`);
                    const empresa = response.data[0]
                    console.log(empresa.nome)
                    setRazaoSocial(empresa.nome);
                    setCEI(empresa.cei);
                    setInscricaoEstadual(empresa.ie);
                    setCnae(empresa.cnae);
                    setTelefone(empresa.tel_com);
                    setCelular(empresa.tel_cel);
                    setSite(empresa.site);
                    setCep(empresa.cep);
                    setEndereco(empresa.end);
                    setNumero(empresa.num);
                    setBairro(empresa.bairro);
                    setComplemento(empresa.comp);
                    setobs(empresa.obs);

                    setIsLoading(false);
                    handleCepChange({ target: { value: empresa.cep } });
                } catch (error) {
                    console.error('Erro ao buscar dados da empresa:', error);

                }
            };

            buscarDadosEmpresa();

        }
    }, [cnpj]);


    useEffect(() => {
        const fetchResponsaveis = async () => {
            try {
                const response = await api.get('listar-responsaveis');
                setResponsaveis(response.data);
            } catch (error) {
                console.error('Erro ao buscar responsáveis', error);
            }
        };

        fetchResponsaveis();
    }, []);

    const checkRequiredFields = () => {
        let missingFields = [];
        if (!cnpj) missingFields.push('CNPJ');
        if (!razaoSocial) missingFields.push('Razão Social');
        if (!cnae) missingFields.push('CNAE');
        if (!celular) missingFields.push('Celular');
        if (!cep) missingFields.push('CEP');
        if (!email) missingFields.push('EMAIL');
        if (!numero) missingFields.push('Número');
        if (!respNome) missingFields.push('Nome do Responsável');
        if (!respCargo) missingFields.push('Cargo do Responsável');
        if (!respTelefone) missingFields.push('Telefone do Responsável');
        if (!respEmail) missingFields.push('Email do Responsável');
        if (!idResponsavel) missingFields.push('Responsável pelo PGR');

        setFieldErrors(missingFields)

        if (missingFields.length > 0) {
            setAlert({ message: `Por favor, preencha os seguintes campos: ${missingFields.join(', ')}.`, variant: 'danger', show: true });
            return false;
        }
        return true;
    };


    const handleSubmit = async (event: any) => {
        event.preventDefault();

        if (!checkRequiredFields()) {
            return
        } else {
            setIsLoading(true)
        }
        if (!checkRequiredFields()) {
            return
        } else {
            setIsLoading(true)
        }

        const payload = {
            cnpj,
            nome: razaoSocial,
            cei,
            cnae,
            insc_estadual: inscricaoEstadual,
            telefone,
            celular,
            site,
            cep,
            endereco,
            numero,
            bairro,
            complemento,
            estado,
            cidade,
            obs,
            email,
            id_responsavel: idResponsavel,
            resp_empresa_nome: respNome,
            resp_empresa_cargo: respCargo,
            resp_empresa_telefone: respTelefone,
            resp_empresa_email: respEmail,
            indicacao_venda: {
                uuid_credenciado: cre || rep || undefined
            }
        }

        try {
            const response = await api.post('/empresas/cadastro', payload);

            if (response.data.data === 'CNAE Inválido') {
                setIsLoading(false);
                setAlert({ message: 'CNAE inválido!', variant: 'danger', show: true });
                return;
            }

            if (response.data.data === 'CNPJ já cadastrado') {
                setIsLoading(false);
                setAlert({ message: 'CNPJ já cadastrado!', variant: 'danger', show: true });
                return;
            }

            if (response.data.data === 'Já existe um usuário cadastrado com o e-mail fornecido') {
                setIsLoading(false)
                setAlert({ message: 'E-MAIL já cadastrado!', variant: 'danger', show: true });
                return;
            }

            if (response.status == 200) {
                setAlert({ message: 'Empresa cadastrada', variant: 'success', show: true });

                setRazaoSocial('');
                setCnpj('');
                setCEI('');
                setInscricaoEstadual('');
                setCnae('');
                setTelefone('');
                setCelular('');
                setCep('');
                setEndereco('');
                setNumero('');
                setBairro('');
                setComplemento('');
                setEstado('');
                setCidade('');
                setobs('');
                setEmail('');
                setSite('');
                setRespCargo('');
                setRespNome('');
                setRespTelefone('');
                setRespEmail('');

                setResponsavelId(null);
                setResponsavelSelecionado(null);
            } else {
                setIsLoading(false)
                setAlert({ message: 'Ocorreu um erro, revise as informações e tente novamente!', variant: 'warning', show: true });
            }
        } catch (error) {
            console.error('Erro ao enviar dados do formulário:', error);
            setAlert({ message: 'Não foi possível cadastrar a empresa, verifique os dados.', variant: 'danger', show: true });
        }

        setIsLoading(false);
    };

    const handleSelectResponsavel = (id: any) => {
        setResponsavelId(id);
    };


    const handleCepChange = async (e: any) => {
        const cep = e.target.value.replace(/\D/g, '');
        setCep(cep);

        if (cep.length === 8) {
            try {
                const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);

                if (response.data.erro) {
                    setAlert({ message: 'CEP Inválido.', variant: 'danger', show: true });
                } else {
                    const { logradouro, bairro, localidade, uf } = response.data;
                    setEndereco(logradouro);
                    setBairro(bairro);
                    setEstado(uf);
                    setCidade(localidade);
                }
            } catch (error) {
                console.error('Erro ao buscar o CEP', error);
            }
        }
    };


    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='../../' />
            <Main>
                <Form onSubmit={handleSubmit}>
                    <h3>Cadastro da Empresa</h3>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Razão Social' htmlFor="razao_social" />
                                <span style={{ color: 'red' }}> *</span>
                                <input
                                    type="text"
                                    id="razao_social"
                                    placeholder="Digite a Razão Social"
                                    value={razaoSocial}
                                    onChange={(e) => {
                                        setRazaoSocial(e.target.value);
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='CNPJ' htmlFor="cnpj" />
                                <span style={{ color: 'red' }}> *</span>
                                <InputMask
                                    ref={inputRef}
                                    mask="**.***.***/****-99"
                                    id='cnpj'
                                    value={cnpj}
                                    onChange={(e: any) => setCnpj(e.target.value.toUpperCase())}
                                    placeholder="Digite o CNPJ"
                                    style={{ width: '100%', textTransform: 'uppercase' }}
                                    className={fieldError.cnpj ? 'invalid-field' : ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='CAEPF' htmlFor="cei" />
                                <InputMask
                                    ref={inputRef}
                                    mask="999.999.999/999-99"
                                    value={cei}
                                    onChange={(e: any) => setCEI(e.target.value)}
                                    placeholder="Digite o CAEPF"
                                    style={{ width: '100%' }}
                                    className={fieldError.cei ? 'invalid-field' : 'form-control'}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='CNAE' htmlFor="cnae" />
                                <span style={{ color: 'red' }}> *</span>
                                <InputMask
                                    ref={inputRef}
                                    mask="9999-9/99"
                                    value={cnae}
                                    onChange={(e: any) => setCnae(e.target.value)}
                                    placeholder="Digite o CNAE"
                                    style={{ width: '100%' }}
                                    className={fieldError.cnae ? 'invalid-field' : 'form-control'}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Inscrição Estadual' htmlFor="cnpj" />
                                <InputMask
                                    ref={inputRef}
                                    mask="99999-999"
                                    id='inscricao_estadual'
                                    value={inscricaoEstadual}
                                    onChange={(e: any) => setInscricaoEstadual(e.target.value)}
                                    placeholder="Digite a Inscrição Estadual"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='E-mail' htmlFor="email" />
                                <span style={{ color: 'red' }}> *</span>
                                <input
                                    type="text"
                                    id="email"
                                    placeholder="Digite o E-mail"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Telefone' htmlFor="telefone" />
                                <InputMask
                                    ref={inputRef}
                                    mask="(99) 9999-9999"
                                    value={telefone}
                                    onChange={(e: any) => setTelefone(e.target.value)}
                                    placeholder="(__) ____-____"
                                    style={{ width: '100%' }}
                                    className={fieldError.telefone ? 'invalid-field' : ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Celular' htmlFor="celular" />
                                <span style={{ color: 'red' }}> *</span>
                                <InputMask
                                    ref={inputRef}
                                    mask="(99) 99999-9999"
                                    value={celular}
                                    onChange={(e: any) => setCelular(e.target.value)}
                                    placeholder="(__) _____-____"
                                    style={{ width: '100%' }}
                                    className={fieldError.celular ? 'invalid-field' : ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Site' htmlFor="site" />
                                <InputMask
                                    ref={inputRef}
                                    value={site}
                                    onChange={(e: any) => setSite(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Responsável Geral' htmlFor="responsavelGeral" />
                                <span style={{ color: 'red' }}> *</span>
                                <input
                                    type="text"
                                    id="responsavel_geral"
                                    placeholder="Digite o Responsável pela empresa"
                                    value={respNome}
                                    onChange={(e) => {
                                        setRespNome(e.target.value);
                                    }}
                                    style={{ width: '100%' }}
                                    className={fieldError.respNome ? 'invalid-field' : ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Cargo do Responsável Geral' htmlFor="celular" />
                                <span style={{ color: 'red' }}> *</span>
                                <input
                                    type="text"
                                    id="responsavel_geral"
                                    placeholder="Digite o Cargo do Responsável"
                                    value={respCargo}
                                    onChange={(e) => {
                                        setRespCargo(e.target.value);
                                    }}
                                    style={{ width: '100%' }}
                                    className={fieldError.respCargo ? 'invalid-field' : ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Telefone do Responsável Geral' htmlFor="site" />
                                <span style={{ color: 'red' }}> *</span>
                                <InputMask
                                    ref={inputRef}
                                    mask="(99) 9999-9999"
                                    value={respTelefone}
                                    onChange={(e: any) => setRespTelefone(e.target.value)}
                                    placeholder="(__) ____-____"
                                    style={{ width: '100%' }}
                                    className={fieldError.respTelefone ? 'invalid-field' : ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Email do Responsável Geral' htmlFor="responsavelGeral" />
                                <span style={{ color: 'red' }}> *</span>
                                <input
                                    type="text"
                                    id="responsavel_geral"
                                    placeholder="Digite o Email do Responsável"
                                    value={respEmail}
                                    onChange={(e) => {
                                        setRespEmail(e.target.value);
                                    }}
                                    style={{ width: '100%' }}
                                    className={fieldError.respEmail ? 'invalid-field' : ''}
                                />
                            </FormGroup>
                        </Col>

                    </Row>

                    <h3>Endereço</h3>
                    <Row>
                        <Col xs={12} md={3}>
                            <FormGroup>
                                <Label title='CEP' htmlFor="cep" />
                                <span style={{ color: 'red' }}> *</span>
                                <InputMask
                                    ref={inputRef}
                                    mask="99999-999"
                                    type="text"
                                    id="cep"
                                    placeholder="Digite o CEP"
                                    value={cep}
                                    onChange={handleCepChange}
                                    style={{ width: '100%' }}
                                    className={fieldError.cep ? 'invalid-field' : ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6}>
                            <FormGroup>
                                <Label title='Endereço' htmlFor="endereco" />
                                <input
                                    type="text"
                                    id="endereco"
                                    placeholder="Endereço"
                                    value={endereco}
                                    onChange={(e) => setEndereco(e.target.value)}
                                    style={{ width: '100%' }}
                                    disabled
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3}>
                            <FormGroup>
                                <span style={{ color: 'red' }}> *</span>
                                <Label title='Número' htmlFor="numero" />
                                <input
                                    type="text"
                                    id="numero"
                                    placeholder="Número"
                                    value={numero}
                                    onChange={(e) => setNumero(e.target.value)}
                                    style={{ width: '100%' }}
                                    className={fieldError.numero ? 'invalid-field' : ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row className='my-4'>
                        <Col xs={12} md={6}>
                            <FormGroup>
                                <Label title='Bairro' htmlFor="bairro" />
                                <input
                                    type="text"
                                    id="bairro"
                                    placeholder="Bairro"
                                    value={bairro}
                                    onChange={(e) => setBairro(e.target.value)}
                                    style={{ width: '100%' }}
                                    disabled
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6}>
                            <FormGroup>
                                <Label title='Complemento' htmlFor="complemento" />
                                <input
                                    type="text"
                                    id="complemento"
                                    placeholder="Complemento"
                                    value={complemento}
                                    onChange={(e) => setComplemento(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} md={6}>
                            <FormGroup>
                                <Label title='Cidade' htmlFor="cidade" />
                                <input
                                    type="text"
                                    id="cidade"
                                    placeholder="Cidade"
                                    value={cidade}
                                    onChange={(e) => setCidade(e.target.value)}
                                    style={{ width: '100%' }}
                                    disabled
                                />
                            </FormGroup>
                        </Col>

                        <Col xs={12} md={6}>
                            <FormGroup>
                                <Label title='Estado' htmlFor="estado" />
                                <input
                                    type="text"
                                    id="estado"
                                    placeholder="Estado"
                                    value={estado}
                                    onChange={(e) => setEstado(e.target.value)}
                                    style={{ width: '100%' }}
                                    disabled
                                />
                            </FormGroup>
                        </Col>

                    </Row>
                    <h3 style={{ marginTop: '10px' }}>Responsável - PGR <span style={{ color: 'red' }}>*</span></h3>
                    <Row>
                        <Col xs={12} md={6}>
                            <FormGroup>
                                <Select id="selectResponsavel" value={idResponsavel} onSelect={handleSelectResponsavel}>
                                    {responsaveis.map((responsavel: any) => (
                                        <Options
                                            key={responsavel.id}
                                            value={responsavel.id}
                                            name={responsavel.nome}
                                            selected={responsavel.id === idResponsavel}
                                        />
                                    ))}
                                </Select>
                            </FormGroup>
                        </Col>

                    </Row>

                    <Row className='mt-4'>
                        <Col xs={12}>
                            <FormGroup>
                                <Label title='Observações' htmlFor="obs" />
                                <textarea
                                    id="obs"
                                    placeholder="Digite observações"
                                    value={obs}
                                    onChange={(e) => setobs(e.target.value)}
                                    style={{ width: '100%', minHeight: '100px' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Button className="btn-main mt-4" type="submit">Inserir Empresa</Button>
                </Form>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div>
    );
}
